<template>
  <div class="box">
    <!--选择切换语言-->
    <el-select v-model="langvalue" placeholder="请选择" @change="selectLang">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { messages } from "@/lang";
export default {
  name: "App",
  props:{
    langu:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      langvalue: "",
      options: [
        {
          value: "ch",
          label: "中文"
        },
        {
          value: "en",
          label: "English"
        },
        {
          value: "jp",
          label: "日本語"
        },
        {
          value: "ka",
          label: "한국어"
        }
      ],
      language: "ch"
    };
  },
  created() {
    let langvalue = window.localStorage.getItem("language")||'ch';

    if(this.langu==1 || langvalue=='' || langvalue=='ch'){
      this.langvalue = 'ch';
    }else{
      this.langvalue =langvalue;
    }

   
   
    // if (this.langvalue == "ch") {
    //   this.options = [
    //     {
    //       value: "ch",
    //       label: "中文"
    //     },
    //     {
    //       value: "en",
    //       label: "英文"
    //     },
    //     {
    //       value: "jp",
    //       label: "日语"
    //     },
    //     {
    //       value: "ka",
    //       label: "韩语"
    //     }
    //   ];
    // }
    // if (this.langvalue == "en") {
    //   this.options = [
    //     {
    //       value: "ch",
    //       label: "China"
    //     },
    //     {
    //       value: "en",
    //       label: "English"
    //     },
    //     {
    //       value: "jp",
    //       label: "Japanese"
    //     },
    //     {
    //       value: "ka",
    //       label: "Korean"
    //     }
    //   ];
    // }
    // if (this.langvalue == "jp") {
    //   this.options = [
    //     {
    //       value: "ch",
    //       label: "中国語"
    //     },
    //     {
    //       value: "en",
    //       label: "英語"
    //     },
    //     {
    //       value: "jp",
    //       label: "日本語"
    //     },
    //     {
    //       value: "ka",
    //       label: "韓国語"
    //     }
    //   ];
    // }
  
    // if (this.langvalue == "ka") {
    //   this.options = [
    //       {
    //         value: "ch",
    //         label: "중국어"
    //       },
    //       {
    //         value: "en",
    //         label: "영어"
    //       },
    //       {
    //         value: "jp",
    //         label: "일본어"
    //       },
    //       {
    //         value: "ka",
    //         label: "한국어"
    //       }
    //     ];
    // }
  },
  methods: {
    selectLang(val) {
      if (val == "ch") {
        this.$router.replace({
          path: "home"
        });
      } else {
        this.$emit("refresh", val);
        this.$router.push({
          path: "/glIndex?lang=" + val
        });
      }

    //   if (this.langvalue == "ch") {
    //   this.options = [
    //     {
    //       value: "ch",
    //       label: "中文"
    //     },
    //     {
    //       value: "en",
    //       label: "English"
    //     },
    //     {
    //       value: "jp",
    //       label: "日本語"
    //     },
    //     {
    //       value: "ka",
    //       label: "韓国語"
    //     }
    //   ];
    // }
    // if (this.langvalue == "en") {
    //   this.options = [
    //     {
    //       value: "ch",
    //       label: "China"
    //     },
    //     {
    //       value: "en",
    //       label: "English"
    //     },
    //     {
    //       value: "jp",
    //       label: "Japanese"
    //     },
    //     {
    //       value: "ka",
    //       label: "Korean"
    //     }
    //   ];
    // }
    // if (this.langvalue == "jp") {
    //   this.options = [
    //     {
    //       value: "ch",
    //       label: "中国語"
    //     },
    //     {
    //       value: "en",
    //       label: "英語"
    //     },
    //     {
    //       value: "jp",
    //       label: "日本語"
    //     },
    //     {
    //       value: "ka",
    //       label: "韓国語"
    //     }
    //   ];
    // }
    // if (this.langvalue == "ka") {
    //   this.options = [
    //     {
    //       value: "ch",
    //       label: "중국어"
    //     },
    //     {
    //       value: "en",
    //       label: "영어"
    //     },
    //     {
    //       value: "jp",
    //       label: "일본어"
    //     },
    //     {
    //       value: "ka",
    //       label: "한국어"
    //     }
    //   ];
    // }


      window.localStorage.setItem("language", val);
    }
  }
};
</script>

<style>
.box {
  width: 120px;
  height: 46px;
}
.el-input__inner {
  height: 46px;
  border-radius: 10px;
  background: #336666;
  font-size: 20px;
  color: #fff;
}
.el-select-dropdown__item {
  font-size: 20px;
  height: 44px;
  line-height: 44px;
}
.el-select-dropdown__item.hover {
  background: #4eae98;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/languageSwitch.vue